import { getAuditActionMeta } from "../../utils";
import { INTENT_STYLES } from "./auditActionStyles";

export default function AuditActionIcon({ action }: { action: string }) {
  const { intent } = getAuditActionMeta(action);
  const { Icon, className } = INTENT_STYLES[intent];
  return (
    <span
      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ring-1 ${className}`}
    >
      <Icon size={14} />
    </span>
  );
}
